
import Api from '@/utils/api';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'

import {
getAddrList
} from '../../api';
export default {
methods: {

addressTap() {
if (this.list.length) {
this.show1 = true;
} else {
this.$router.push({
name: 'AddAddress',
params: {
pathName: 'add'
}
})
}
},

addressListTap(item) {
if(!this.addressInfo || this.addressInfo._id != item._id){
this.$emit('changeAddressInfo', item)
}
this.show1 = false;
},
toShippAddress() {
this.$router.push({
name: 'shippingAddress'
})
},
getAddrList() {
Api.getAddressList().then(res => {
this.list = res.data
})
},
resetScroller() {
this.$nextTick(() => {
this.$refs.scroller.reset()
})
},
getDefaultAddress() {
Api.getDefaultAddress().then(res => {
this.addressInfo = res.data
})
}
},
data() {
return {
show1: false,
list: ""
}
},
directives: {
TransferDom
},
components: {
Popup,
Scroller
},
props: ['addressInfo'],
mounted() {
this.getAddrList()
},
computed: {
boxHeight() {
return (document.body.scrollHeight / 2 - 40 - 45) + 'px'
}
}
}



// WEBPACK FOOTER //
// ./src/components/CreateOrder/BuyerAddress.vue